import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_NEURAXIS_API_MAIN;
const JWTtoken = localStorage.getItem(process.env.VUE_APP_NEURAXIS_TOKENNAME);
axios.defaults.headers.common['Authorization'] = `${JWTtoken}`;

export default axios;